const moduleSelectedPatient = {
    namespaced: true,
    state: {
        loading: false,
        searchDataPatient: {},
        selectedPatient: {
            rut: "",
        },
    },
    getters: {
        getSelectedPatient(state) {
            return state.selectedPatient;
        },
        getSearchPatient(state) {
            return state.searchDataPatient;
        },
        getLoading(state) {
            return state.loading;
        },
    },
    mutations: {
        cleanSelectedPatient(state) {
            state.searchDataPatient = {};
            state.selectedPatient = {
                rut: "",
            };
        },
        setSelectedPatient(state, selectedPatient) {
            state.selectedPatient = selectedPatient;
        },
        setSearchDataPatient(state, searchDataPatient) {
            state.searchDataPatient = searchDataPatient;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
    },
};
export default moduleSelectedPatient;
